import Notice from '@/components/common/Notice'
import CustomModal from '@/components/ui/ui-react-antd/Modal/CustomModal'
import Button from '@/components/ui/ui-react-antd/MyButton/Button'
import AuthService from '@/shared/services/AuthService' // Thêm AuthService
import IdentityService from '@/shared/services/IdentityService' // Giả định service này tồn tại
import { getRegexPassword } from '@/shared/utils/stringsUtils'
import { Col, Form, Input, Row } from 'antd'
import { useState } from 'react'

const RePasswordModal = ({
  rePasswordModal,
  handleCancel,
  handleLogin,
  email,
  codeVerify,
}: any) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  const handleSubmit = async () => {
    try {
      setLoading(true)
      const values = await form.validateFields()
      let res: any

      if (codeVerify) {
        // Đây là luồng "Quên mật khẩu"
        // Gọi AuthService.forgotPassword với OTP và mật khẩu mới thật sự
        res = await AuthService.forgotPassword({
          code: codeVerify,
          email: email,
          newPassword: values.pass, // Mật khẩu mới thật sự từ người dùng
        })
      } else {
        // Đây là luồng "Đổi mật khẩu" (khi đã đăng nhập)
        res = await IdentityService.changePassword({
          oldPassword: values.passOld,
          newPassword: values.pass,
        })
      }

      if (res.isError || !res.isOk) return

      Notice({
        isSuccess: true,
        msg: 'Cập nhật mật khẩu thành công',
      })
      handleCancel()
      handleLogin() // Quay lại màn hình đăng nhập sau khi cập nhật thành công
    } catch (_error) {
    } finally {
      setLoading(false)
    }
  }
  return (
    <CustomModal
      title={codeVerify ? 'Quên mật khẩu' : 'Đổi mật khẩu'}
      width="600px"
      footer={null}
      open={rePasswordModal}
      onCancel={handleCancel}
    >
      <Row gutter={[14, 24]}>
        <Col span={24}>
          <Form form={form} layout="vertical">
            {!codeVerify && ( // Hiển thị trường mật khẩu cũ chỉ khi không phải là luồng quên mật khẩu
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: 'Bạn chưa nhập mật khẩu cũ!',
                  },
                  {
                    pattern: getRegexPassword(),
                    message:
                      'Mật khẩu có chứa ít nhất 8 ký tự, trong đó có ít nhất một số và bao gồm cả chữ thường và chữ hoa và ký tự đặc biệt, ví dụ @, #, ?, !.',
                  },
                ]}
                label={'Mật khẩu cũ'}
                name="passOld"
              >
                <Input.Password placeholder="Nhập" />
              </Form.Item>
            )}
            <Form.Item
              rules={[
                {
                  required: true,
                  message: 'Bạn chưa nhập mật khẩu mới!',
                },
                {
                  pattern: getRegexPassword(),
                  message:
                    'Mật khẩu có chứa ít nhất 8 ký tự, trong đó có ít nhất một số và bao gồm cả chữ thường và chữ hoa và ký tự đặc biệt, ví dụ @, #, ?, !.',
                },
              ]}
              label={codeVerify ? 'Mật khẩu ' : 'Mật khẩu mới'}
              name="pass"
            >
              <Input.Password placeholder="Nhập" />
            </Form.Item>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: 'Bạn chưa nhập lại mật khẩu mới!',
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('pass') === value) {
                      return Promise.resolve()
                    }
                    return Promise.reject(
                      new Error('Mật khẩu nhập lại phải giống với mật khẩu mới!')
                    )
                  },
                }),
              ]}
              label="Nhập lại mật khẩu "
              name="rePass"
            >
              <Input.Password placeholder="Nhập" />
            </Form.Item>
          </Form>
          <Row>
            <Button
              loading={loading}
              className="btn-w100"
              htmlType="submit"
              onClick={() => {
                handleSubmit()
              }}
            >
              Cập nhật
            </Button>
          </Row>
        </Col>
      </Row>
      {codeVerify && ( // Chỉ hiển thị "Quay lại Đăng nhập" nếu đây là luồng quên mật khẩu
        <Row>
          <span className="md-bottom-text">
            Quay lại
            <span
              className="link-regis"
              onClick={() => {
                handleLogin()
                handleCancel()
              }}
            >
              Đăng nhập
            </span>
          </span>
        </Row>
      )}
    </CustomModal>
  )
}

export default RePasswordModal
